import { render, staticRenderFns } from "./im-custom-message.vue?vue&type=template&id=21417fca&scoped=true"
import script from "./im-custom-message.vue?vue&type=script&lang=js"
export * from "./im-custom-message.vue?vue&type=script&lang=js"
import style0 from "./im-custom-message.vue?vue&type=style&index=0&id=21417fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21417fca",
  null
  
)

export default component.exports